import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

import { useModal } from 'hooks/useModal';
import { Category, Document } from 'interfaces/documents';
import { useAppDispatch } from 'utilities/hooks';
import { isCategory, isDocument } from '../../../utilities/constants';
import { foreverDeleteCategory } from 'slices/categoriesActions';
import { fetchDeletedDocuments, foreverDeleteDocument } from 'slices/documentsActions';

interface DocumentsToolbarButtonDeleteProps {
    selected: (Category | Document)[];
    isDisable: boolean;
}

export const DocumentsToolbarButtonDelete: React.FC<DocumentsToolbarButtonDeleteProps> = ({ selected, isDisable }) => {
    const dispatch = useAppDispatch();
    const { openModal: openConfirmationDeleteForeverModal } = useModal();

    const handleDeleteForever = () => {
        const promises: Promise<any>[] = [];

        selected.map((item: Category | Document) => {
            if (isCategory(item)) {
                promises.push(dispatch(foreverDeleteCategory(item.id)));
            } else if (isDocument(item)) {
                promises.push(dispatch(foreverDeleteDocument(item.id)));
            }
        });

        Promise.all(promises)
            .then(() => dispatch(fetchDeletedDocuments()))
            .catch(() => {});
    };

    const handleConfirmDeleteForever = () => {
        handleDeleteForever();
    };

    return (
        <Button
            type="primary"
            disabled={isDisable}
            onClick={() => {
                openConfirmationDeleteForeverModal(
                    'confirmationModal',
                    {
                        text: 'Are you sure want to the selected item(s) delete forever?',
                    },
                    {
                        onConfirm: handleConfirmDeleteForever,
                    },
                );
            }}
            icon={<DeleteOutlined />}
        >
            Delete Forever
        </Button>
    );
};
